import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    id: 1,
    image: image1,
    name: 'SURESH KUMAR',
    status: 'TRANSFORMATION MEMBER (UNIT 1)',
    branch: 'Chettipalayam JJ Nagar',
    rating: 5,
    achievement: 'Lost 16 kg & Gained Muscle in 5 Months',
    review:
      "Joining IDOL FITNESS ZONE changed my life. Trainer Sanjay created a dedicated nutrition and progressive strength plan. The Olympic equipment and supportive community kept me consistent every single day!",
  },
  {
    id: 2,
    image: image2,
    name: 'VIGNESHWARAN R.',
    status: 'POWERLIFTER & ATHLETE (UNIT 2)',
    branch: 'Pappampatti Pirivu',
    rating: 5,
    achievement: '180 kg Squat & 210 kg Deadlift',
    review:
      "The heavy strength setup at Unit 2 Pappampatti is top tier. Olympic squat racks, calibrated plates, and spotting support from coach Karthikeyan helped me hit personal records safely.",
  },
  {
    id: 3,
    image: image3,
    name: 'NITHYA PRAKASH',
    status: 'FITNESS & CARDIO MEMBER (UNIT 3)',
    branch: 'Peedampalli',
    rating: 5,
    achievement: 'Improved Stamina & Toned Physique',
    review:
      "The unisex workout environment at Peedampalli is super clean, safe, and motivating. The spin bikes and cable machines are state-of-the-art. Highly recommend to everyone in Coimbatore!",
  }
];
